/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, inject, input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UpdateUserComponent } from '../update-user/update-user.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UserEndpointService, UserDetailDto } from '@api';
import { ConfirmationService } from '../../services/confirmation.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss',
})
export class UserDetailComponent implements OnInit {
  details: UserDetailDto = {
    username: '',
    tournaments: [],
    startedTournaments: 0,
    notStartedTournaments: 0,
  };

  router = inject(Router);
  route = inject(ActivatedRoute);
  snackBar = inject(MatSnackBar);
  authService = inject(AuthService);
  userService = inject(UserEndpointService);
  matDialog = inject(MatDialog);
  confirmationService = inject(ConfirmationService);

  username = input<string>();

  ngOnInit(): void {
    if (this.username() !== undefined) {
      this.details.username = this.username()!;
      console.log(this.details.username);
      this.userService.details(this.details.username).subscribe({
        next: (data: UserDetailDto) => {
          this.details = data;
        },
        error: error => {
          console.error('Error fetching user data', error);
          this.defaultServiceErrorHandling(error);
        },
      });
    }
  }

  async onDelete() {
    console.log('Delete user');

    if (
      await this.confirmationService.openConfirmationDialog(
        `Delete '${this.details.username}'`,
        undefined,
        true,
        'Delete',
      )
    ) {
      this.userService._delete(this.details.username).subscribe({
        next: _ => {
          this.authService.logoutUser();
          this.router.navigate(['/admin/']);
        },
        error: error => {
          console.error('Error deleting user', error);
          this.defaultServiceErrorHandling(error);
        },
      });
    }
  }

  onChange() {
    console.log('Change user information');
    this.matDialog.open(UpdateUserComponent, {
      width: '500px',
      data: { username: this.details.username, password: '' },
    });
  }

  private defaultServiceErrorHandling(error: HttpErrorResponse) {
    let errorMessage = '';
    if (typeof error.error === 'object') {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }
    this.snackBar.open(errorMessage, 'Close', {
      duration: 5000,
    });
  }

  async genTestData() {
    await firstValueFrom(this.userService.generateTestData()).then(
      () => {
        this.snackBar.open('Successfully generated test data', 'Close', {
          duration: 5000,
        });
      },
      (error: HttpErrorResponse) => {
        console.error('Error generating test data', error);
        this.defaultServiceErrorHandling(error);
      },
    );
  }
}
